
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/user/auctions",
      function () {
        return require("private-next-pages/user/auctions/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/user/auctions"])
      });
    }
  